var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfConverter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 188,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9213_2127)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2987 121.027C24.9686 95.6013 49.7018 75.7782 78.6493 62.9529C107.794 50.0403 144.3 42.2322 177.142 53.3088C208.228 63.7932 219.091 90.239 229.525 113.839C239.039 135.359 250.758 160.691 231.842 177.038C214.024 192.436 179.489 180.852 150.994 181.705C124.625 182.494 98.4092 192.678 75.5201 181.716C46.8381 167.98 23.6628 145.16 24.2987 121.027Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.804 38.3501C131.804 38.61 131.594 38.8201 131.334 38.8201C131.074 38.8201 130.864 38.61 130.864 38.3501C130.864 38.0903 131.074 37.8801 131.334 37.8801C131.594 37.8801 131.804 38.0903 131.804 38.3501Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9985 118.72H181.61V120.696C181.61 121.162 181.218 121.54 180.738 121.54H83.2456C82.5574 121.54 81.9985 120.999 81.9985 120.332V118.72Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2742 36H190.863C192.239 36 193.356 37.1158 193.356 38.491V115.509C193.356 118.06 191.284 120.13 188.732 120.13H74.4053C71.8531 120.13 69.7817 118.06 69.7817 115.509V38.491C69.7817 37.1158 70.8982 36 72.2742 36Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.597 116.021V40.5788C189.597 40.3862 189.441 40.23 189.249 40.23L73.8891 40.23C73.6968 40.23 73.5409 40.3862 73.5409 40.5788V116.021C73.5409 116.214 73.6968 116.37 73.8891 116.37H189.249C189.441 116.37 189.597 116.214 189.597 116.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.258 149.247V148.596L43 148.33V149.248C43 151.336 45.0581 153.03 47.5966 153.03H213.662C216.201 153.03 218.259 151.337 218.259 149.248L218.258 149.247Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.377 149.27H44.8816C42.996 149.27 42.4411 148.375 43.6128 147.298L70.9767 122.143C71.7277 121.452 72.7073 121.07 73.7231 121.07H187.536C188.552 121.07 189.531 121.453 190.282 122.143L217.646 147.298C218.818 148.375 218.263 149.27 216.378 149.27H216.377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.279 125.3H75.8148C75.4946 125.3 75.337 125.195 75.4649 125.066L76.8806 123.641C77.0015 123.52 77.3535 123.42 77.6638 123.42H84.8801C85.1904 123.42 85.3599 123.52 85.2578 123.641L84.0592 125.066C83.9512 125.195 83.6002 125.3 83.279 125.3Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.534 125.3H85.229C84.9156 125.3 84.7439 125.195 84.8477 125.066L85.9974 123.641C86.0954 123.52 86.4234 123.42 86.727 123.42H93.7895C94.0932 123.42 94.2756 123.52 94.196 123.641L93.2587 125.066C93.1743 125.195 92.8483 125.3 92.534 125.3Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.175 125.3H94.6665C94.3444 125.3 94.1499 125.195 94.2347 125.066L95.1751 123.641C95.2549 123.52 95.576 123.42 95.8872 123.42H103.146C103.458 123.42 103.663 123.52 103.601 123.641L102.88 125.066C102.815 125.195 102.498 125.3 102.175 125.3Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.069 125.3H113.528C113.204 125.3 112.973 125.195 113.014 125.066L113.473 123.641C113.512 123.52 113.8 123.42 114.113 123.42H121.404C121.717 123.42 121.956 123.52 121.935 123.641L121.697 125.066C121.675 125.195 121.393 125.3 121.069 125.3Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.416 125.3H104.083C103.769 125.3 103.561 125.195 103.623 125.066L104.304 123.641C104.363 123.52 104.659 123.42 104.964 123.42H112.053C112.358 123.42 112.574 123.52 112.534 123.641L112.066 125.066C112.024 125.195 111.731 125.3 111.416 125.3Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.726 125.3H132.406C132.092 125.3 131.832 125.195 131.83 125.066L131.804 123.641C131.802 123.52 132.049 123.42 132.352 123.42H139.43C139.734 123.42 139.999 123.52 140.02 123.641L140.26 125.066C140.281 125.195 140.042 125.3 139.728 125.3H139.726Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.616 125.3H142.103C141.781 125.3 141.496 125.195 141.472 125.066L141.203 123.641C141.18 123.52 141.416 123.42 141.729 123.42H148.993C149.305 123.42 149.593 123.52 149.635 123.641L150.123 125.066C150.167 125.195 149.94 125.3 149.617 125.3H149.616Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.59 125.3H151.284C150.97 125.3 150.676 125.195 150.632 125.066L150.134 123.641C150.091 123.52 150.305 123.42 150.608 123.42H157.672C157.976 123.42 158.273 123.52 158.334 123.641L159.044 125.066C159.108 125.195 158.904 125.3 158.59 125.3Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.477 125.3H160.995C160.674 125.3 160.355 125.195 160.288 125.066L159.538 123.641C159.474 123.52 159.676 123.42 159.986 123.42H167.219C167.53 123.42 167.851 123.52 167.933 123.641L168.902 125.066C168.989 125.195 168.799 125.3 168.477 125.3Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.755 125.3H170.387C169.938 125.3 169.467 125.152 169.342 124.971L168.482 123.731C168.363 123.559 168.622 123.42 169.057 123.42H183.914C184.349 123.42 184.843 123.559 185.013 123.731L186.246 124.971C186.425 125.151 186.204 125.3 185.755 125.3Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.292 125.3H122.947C122.632 125.3 122.389 125.195 122.408 125.066L122.617 123.641C122.635 123.52 122.899 123.42 123.205 123.42H130.305C130.611 123.42 130.86 123.52 130.86 123.641L130.864 125.066C130.864 125.195 130.607 125.3 130.292 125.3Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.476 128.12H188.253C188.587 128.12 188.746 127.988 188.607 127.827L187.071 126.046C186.94 125.894 186.57 125.77 186.247 125.77H178.739C178.416 125.77 178.243 125.894 178.354 126.046L179.655 127.827C179.772 127.988 180.142 128.12 180.477 128.12H180.476Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.731 128.12H178.366C178.694 128.12 178.869 127.988 178.756 127.827L177.503 126.046C177.396 125.894 177.05 125.77 176.733 125.77H169.362C169.045 125.77 168.857 125.894 168.944 126.046L169.965 127.827C170.058 127.988 170.401 128.12 170.73 128.12H170.731Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.068 128.12H168.925C169.263 128.12 169.463 127.988 169.371 127.827L168.345 126.046C168.258 125.894 167.92 125.77 167.594 125.77H160.009C159.683 125.77 159.471 125.894 159.538 126.046L160.326 127.827C160.398 127.988 160.732 128.12 161.069 128.12H161.068Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.142 128.12H148.674C148.998 128.12 149.227 127.988 149.183 127.827L148.705 126.046C148.663 125.894 148.375 125.77 148.063 125.77H140.791C140.479 125.77 140.241 125.894 140.263 126.046L140.514 127.827C140.537 127.988 140.819 128.12 141.143 128.12H141.142Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.865 128.12H158.565C158.896 128.12 159.111 127.988 159.044 127.827L158.296 126.046C158.232 125.894 157.919 125.77 157.599 125.77H150.165C149.846 125.77 149.621 125.894 149.664 126.046L150.178 127.827C150.224 127.988 150.534 128.12 150.864 128.12H150.865Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.56 128.12H129.29C129.623 128.12 129.896 127.988 129.898 127.827L129.924 126.046C129.926 125.894 129.666 125.77 129.345 125.77H121.882C121.562 125.77 121.282 125.894 121.259 126.046L120.999 127.827C120.975 127.988 121.227 128.12 121.56 128.12Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.639 128.12H119.146C119.469 128.12 119.753 127.988 119.779 127.827L120.056 126.046C120.08 125.894 119.844 125.77 119.533 125.77H112.284C111.973 125.77 111.684 125.894 111.641 126.046L111.136 127.827C111.09 127.988 111.317 128.12 111.639 128.12Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.747 128.12H109.425C109.755 128.12 110.064 127.988 110.113 127.827L110.654 126.046C110.7 125.894 110.477 125.77 110.159 125.77H102.747C102.429 125.77 102.114 125.894 102.049 126.046L101.276 127.827C101.206 127.988 101.418 128.12 101.748 128.12H101.747Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8591 128.12H99.6906C100.027 128.12 100.362 127.988 100.436 127.827L101.249 126.046C101.318 125.894 101.11 125.77 100.785 125.77H93.2241C92.8993 125.77 92.5606 125.894 92.4706 126.046L91.4194 127.827C91.3244 127.988 91.5213 128.12 91.8581 128.12H91.8591Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6303 128.12H89.3727C89.8332 128.12 90.3191 127.934 90.4515 127.709L91.3639 126.158C91.4895 125.944 91.2286 125.77 90.7836 125.77H75.5856C75.1406 125.77 74.6304 125.944 74.4493 126.158L73.1396 127.709C72.9487 127.935 73.1688 128.12 73.6294 128.12H73.6303Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.47 128.12H139.224C139.557 128.12 139.811 127.988 139.79 127.827L139.557 126.046C139.537 125.894 139.258 125.77 138.937 125.77H131.451C131.129 125.77 130.866 125.894 130.866 126.046L130.864 127.827C130.864 127.988 131.136 128.12 131.47 128.12Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.69 130.47H190.46C190.919 130.47 191.131 130.305 190.932 130.103L189.786 128.939C189.597 128.746 189.079 128.59 188.634 128.59H171.411C170.966 128.59 170.707 128.747 170.835 128.939L171.611 130.103C171.745 130.304 172.232 130.47 172.69 130.47Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.117 130.47H170.32C170.672 130.47 170.877 130.338 170.777 130.176L169.662 128.396C169.566 128.244 169.212 128.12 168.872 128.12H160.964C160.625 128.12 160.406 128.243 160.479 128.396L161.336 130.176C161.413 130.338 161.765 130.47 162.118 130.47H162.117Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.508 130.47H190.593C190.94 130.47 191.1 130.338 190.95 130.176L189.287 128.396C189.145 128.244 188.756 128.12 188.421 128.12H180.628C180.294 128.12 180.118 128.243 180.237 128.396L181.645 130.176C181.773 130.338 182.162 130.47 182.509 130.47H182.508Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.67 130.47H149.591C149.931 130.47 150.17 130.338 150.123 130.176L149.598 128.396C149.554 128.244 149.249 128.12 148.921 128.12H141.286C140.959 128.12 140.71 128.243 140.733 128.396L141.007 130.176C141.032 130.338 141.331 130.47 141.671 130.47H141.67Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.887 130.47H159.956C160.302 130.47 160.526 130.338 160.452 130.176L159.636 128.396C159.567 128.244 159.237 128.12 158.902 128.12H151.125C150.792 128.12 150.557 128.243 150.605 128.396L151.166 130.176C151.216 130.338 151.542 130.47 151.888 130.47H151.887Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.641 133.29H172.185C172.553 133.29 172.762 133.158 172.653 132.997L171.442 131.215C171.339 131.063 170.966 130.94 170.613 130.94H162.389C162.036 130.94 161.812 131.063 161.891 131.215L162.821 132.997C162.905 133.158 163.274 133.29 163.642 133.29H163.641Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.02 133.29H193.405C193.765 133.29 193.925 133.158 193.762 132.997L191.964 131.215C191.81 131.063 191.403 130.94 191.056 130.94H182.987C182.64 130.94 182.462 131.063 182.592 131.215L184.114 132.997C184.252 133.158 184.66 133.29 185.02 133.29Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.192 131.88H181.79C182.018 131.88 182.136 131.8 182.052 131.704L181.537 131.112C181.455 131.017 181.203 130.94 180.977 130.94H172.517C172.292 130.94 172.163 131.017 172.23 131.112L172.651 131.704C172.72 131.8 172.964 131.88 173.192 131.88Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.192 133.29H183.188C183.428 133.29 183.55 133.21 183.459 133.114L182.907 132.521C182.819 132.427 182.554 132.35 182.318 132.35H173.469C173.233 132.35 173.099 132.427 173.171 132.521L173.621 133.114C173.695 133.21 173.951 133.29 174.191 133.29H174.192Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.915 133.29H161.347C161.71 133.29 161.94 133.158 161.859 132.997L160.97 131.215C160.894 131.063 160.547 130.94 160.199 130.94H152.085C151.736 130.94 151.493 131.063 151.545 131.215L152.157 132.997C152.212 133.158 152.554 133.29 152.916 133.29H152.915Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.117 130.47H129.255C129.605 130.47 129.893 130.338 129.896 130.176L129.925 128.396C129.927 128.244 129.654 128.12 129.316 128.12H121.471C121.135 128.12 120.839 128.243 120.815 128.396L120.529 130.176C120.503 130.338 120.768 130.47 121.118 130.47H121.117Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.722 130.47H118.616C118.955 130.47 119.254 130.338 119.282 130.176L119.586 128.396C119.612 128.244 119.366 128.12 119.038 128.12H111.429C111.102 128.12 110.796 128.243 110.75 128.396L110.197 130.176C110.147 130.338 110.384 130.47 110.723 130.47H110.722Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.53 133.29H149.768C150.594 133.29 151.172 132.986 151.052 132.617L150.716 131.577C150.602 131.225 149.859 130.94 149.063 130.94H102.635C101.839 130.94 101.048 131.225 100.874 131.577L100.359 132.617C100.177 132.986 100.702 133.29 101.529 133.29H101.53Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.826 130.47H108.868C109.214 130.47 109.54 130.338 109.594 130.176L110.183 128.396C110.233 128.244 110.002 128.12 109.668 128.12H101.916C101.584 128.12 101.252 128.243 101.181 128.396L100.338 130.176C100.262 130.338 100.481 130.47 100.827 130.47H100.826Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4611 130.47H98.6387C98.99 130.47 99.3432 130.338 99.4233 130.176L100.308 128.396C100.383 128.244 100.168 128.12 99.8286 128.12H91.9461C91.6079 128.12 91.2516 128.243 91.1545 128.396L90.0128 130.176C89.9097 130.338 90.1118 130.47 90.4631 130.47H90.4611Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5421 133.29H98.0866C98.454 133.29 98.8234 133.158 98.9074 132.997L99.8374 131.215C99.9165 131.063 99.6922 130.94 99.3389 130.94H91.1157C90.7623 130.94 90.39 131.063 90.2869 131.215L89.0757 132.997C88.9656 133.158 89.1758 133.29 89.5431 133.29H89.5421Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1563 133.29H87.4406C87.7968 133.29 88.1772 133.158 88.2859 132.997L89.4894 131.215C89.5913 131.063 89.3952 130.94 89.0526 130.94H81.0799C80.7373 130.94 80.3549 131.063 80.2297 131.215L78.7536 132.997C78.6196 133.158 78.8011 133.29 79.1573 133.29H79.1563Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3236 133.29H76.7084C77.0689 133.29 77.4766 133.158 77.6141 132.997L79.1367 131.215C79.2663 131.063 79.0885 130.94 78.7418 130.94H70.6722C70.3255 130.94 69.9178 131.063 69.7646 131.215L67.966 132.997C67.803 133.158 67.9641 133.29 68.3236 133.29Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2973 130.47H87.8099C88.2929 130.47 88.8071 130.284 88.9531 130.058L89.9503 128.508C90.0874 128.294 89.8181 128.12 89.3528 128.12H73.4348C72.9695 128.12 72.4278 128.294 72.2309 128.508L70.7997 130.058C70.5911 130.284 70.8154 130.47 71.2983 130.47H71.2973Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.501 130.47H139.665C140.015 130.47 140.283 130.338 140.26 130.176L140.004 128.396C139.982 128.244 139.689 128.12 139.35 128.12H131.481C131.143 128.12 130.866 128.243 130.866 128.396L130.864 130.176C130.864 130.338 131.151 130.47 131.502 130.47H131.501Z",
    fill: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M162.993 146.92H92.9818C90.4302 146.92 88.9685 145.739 89.7081 144.344L93.515 137.159C94.102 136.05 96.3474 135.17 98.5203 135.17H158.163C160.336 135.17 162.528 136.051 163.049 137.159L166.422 144.344C167.078 145.739 165.545 146.92 162.993 146.92Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5646 121.911V52.0614C99.5646 50.1298 101.128 48.5646 103.056 48.5646H144.864L161.736 65.4588V121.911C161.736 123.843 160.172 125.408 158.244 125.408H103.056C101.129 125.408 99.5646 123.844 99.5646 121.911Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 1.1293
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.677 61.2691V49.3632L160.937 64.6229H149.031C147.179 64.6229 145.677 63.1218 145.677 61.2691Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 1.1293
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.449,
    y: 102.433,
    width: 45.7143,
    height: 15.1338,
    rx: 1.96071,
    fill: "#D2294B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.449,
    y: 102.433,
    width: 45.7143,
    height: 15.1338,
    rx: 1.96071,
    stroke: "#D2294B",
    strokeWidth: 0.897059
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.464 114.015V105.985H123.111C124.002 105.985 124.689 106.212 125.172 106.668C125.655 107.116 125.897 107.743 125.897 108.548C125.897 109.353 125.655 109.983 125.172 110.439C124.689 110.894 124.002 111.122 123.111 111.122H121.219V114.015H119.464ZM121.219 109.755H122.816C123.745 109.755 124.209 109.353 124.209 108.548C124.209 107.758 123.745 107.363 122.816 107.363H121.219V109.755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.985 114.015V105.985H130.111C131.47 105.985 132.523 106.334 133.271 107.033C134.018 107.724 134.392 108.711 134.392 109.994C134.392 111.278 134.018 112.269 133.271 112.967C132.523 113.666 131.47 114.015 130.111 114.015H126.985ZM128.74 112.569H130.009C131.708 112.569 132.557 111.711 132.557 109.994C132.557 108.286 131.708 107.431 130.009 107.431H128.74V112.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.756 114.015V105.985H141.147V107.363H137.511V109.322H140.898V110.701H137.511V114.015H135.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.223 47.3671L166.435 67.795L160.564 60.4485L186.352 40.0206L192.223 47.3671Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.464865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.452 60.8584L166.11 68.0697L160.189 68.8665L160.189 68.8665L157.352 69.2483L158.358 66.5274L158.358 66.5273L160.452 60.8584Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 0.464865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.352 69.2488L158.257 66.8016L159.907 68.9048L157.352 69.2488Z",
    fill: "#3E4FE0",
    stroke: "#1D1D1D",
    strokeWidth: 0.464865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.856 46.2363L192.747 47.1148L186.876 39.7686L187.985 38.8901L193.856 46.2363Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 0.464865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.626 45.7046L188.755 38.3586L191.656 36.0609C192.292 35.557 193.226 35.6652 193.739 36.3077L197.753 41.3302C198.267 41.9727 198.163 42.903 197.527 43.4069L194.626 45.7046Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 0.464865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.223 47.3669L166.435 67.795L164.964 65.9553L190.753 45.5273L192.223 47.3669Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 0.464865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.994 42.197L162.206 62.625L160.736 60.7854L186.524 40.3574L187.994 42.197Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 0.464865
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.828 86.7556L115.082 77.5H116.724L120.978 86.7556H118.93L118.063 84.7469H113.743L112.889 86.7556H110.828ZM115.883 79.6662L114.426 83.1584H117.393L115.909 79.6662H115.883Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.637 86.9C126.181 86.9 125.77 86.7993 125.402 86.598C125.043 86.3967 124.776 86.1298 124.601 85.7972V86.7556H122.658V77.5H124.641V81.176C124.833 80.8696 125.105 80.629 125.455 80.4539C125.814 80.2701 126.208 80.1782 126.637 80.1782C127.197 80.1782 127.687 80.3139 128.107 80.5852C128.536 80.8565 128.869 81.2416 129.105 81.7405C129.342 82.2394 129.46 82.8345 129.46 83.526C129.46 84.2174 129.342 84.8169 129.105 85.3246C128.869 85.8235 128.536 86.2129 128.107 86.493C127.687 86.7643 127.197 86.9 126.637 86.9ZM126.046 85.4165C126.466 85.4165 126.807 85.2633 127.07 84.957C127.333 84.6507 127.464 84.1736 127.464 83.526C127.464 82.8871 127.333 82.4188 127.07 82.1212C126.807 81.8149 126.466 81.6617 126.046 81.6617C125.617 81.6617 125.271 81.8149 125.008 82.1212C124.746 82.4188 124.614 82.8871 124.614 83.526C124.614 84.1736 124.746 84.6507 125.008 84.957C125.271 85.2633 125.617 85.4165 126.046 85.4165Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.49 86.7556V77.5H135.184L138.309 83.1846L141.421 77.5H143.089V86.7556H141.238V81.1103L138.848 85.364H137.705L135.329 81.1497V86.7556H133.49Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.846 86.7556V80.3095H147.79V81.2547C148.009 80.9047 148.302 80.6377 148.67 80.4539C149.037 80.2701 149.449 80.1782 149.904 80.1782C150.666 80.1782 151.235 80.4014 151.611 80.8478C151.987 81.2854 152.176 81.9637 152.176 82.8827V86.7556H150.193V82.9746C150.193 82.5282 150.11 82.2088 149.943 82.0162C149.777 81.8149 149.532 81.7142 149.208 81.7142C148.788 81.7142 148.451 81.8455 148.197 82.1081C147.952 82.3707 147.829 82.7208 147.829 83.1584V86.7556H145.846Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.719 93.95L155.934 93.95",
    stroke: "#3E4FE0",
    strokeWidth: 0.92973,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.585 70.9202L105.659 70.9202",
    stroke: "#3E4FE0",
    strokeWidth: 0.92973,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.935 91.6L155.935 72.8",
    stroke: "#3E4FE0",
    strokeWidth: 0.92973,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.719 70.9202L104.719 92.0702",
    stroke: "#3E4FE0",
    strokeWidth: 0.92973,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.84,
    y: 68.1001,
    width: 5.63836,
    height: 5.64,
    rx: 1.28391,
    fill: "#3E4FE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.646,
    y: 68.1001,
    width: 5.63836,
    height: 5.64,
    rx: 1.28391,
    fill: "#3E4FE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.646,
    y: 89.72,
    width: 5.63836,
    height: 5.64,
    rx: 1.28391,
    fill: "#3E4FE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.84,
    y: 89.72,
    width: 5.63836,
    height: 5.64,
    rx: 1.28391,
    fill: "#3E4FE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9213_2127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260.774,
    height: 188,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfConverter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf_converter.8871913e29e87d443402bd77179c7d98.svg";